/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M17 6.99989L19.3642 4.63574M4.63623 19.3637L7.00019 16.9997M7.00038 6.99989L4.63623 4.63574M19.3642 19.3637L17.0002 16.9997"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.6566 12H22M2 12H5.34315M12 5.34341V2M12 22V18.6569"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<circle opacity="0.12" cx="12" cy="12" r="8" fill="currentColor" />
			<path
				d="M17 6.99989L19.3642 4.63574M4.63623 19.3637L7.00019 16.9997M7.00038 6.99989L4.63623 4.63574M19.3642 19.3637L17.0002 16.9997M18.6566 12H22M2 12H5.34315M12 5.34341V2M12 22V18.6569"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M17 6.99989L19.3642 4.63574M4.63623 19.3637L7.00019 16.9997M7.00038 6.99989L4.63623 4.63574M19.3642 19.3637L17.0002 16.9997M18.6566 12H22M2 12H5.34315M12 5.34341V2M12 22V18.6569"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17 7.00038L19.3642 4.63623M4.63623 19.3642L7.00019 17.0002M7.00038 7.00038L4.63623 4.63623M19.3642 19.3642L17.0002 17.0002M16 12H17M20 12H22M2 12H4M7 12H8M12 8V7M12 4V2M12 22V20M12 17V16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M17 6.99989L19.3642 4.63574M4.63623 19.3637L7.00019 16.9997M7.00038 6.99989L4.63623 4.63574M19.3642 19.3637L17.0002 16.9997M18.6566 12H22M2 12H5.34315M12 5.34341V2M12 22V18.6569"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M17 6.99989L19.3642 4.63574M4.63623 19.3637L7.00019 16.9997M7.00038 6.99989L4.63623 4.63574M19.3642 19.3637L17.0002 16.9997M18.6566 12H22M2 12H5.34315M12 5.34341V2M12 22V18.6569"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
